import { useCallback } from "react";
import { useFlightSearch } from "./useFlightsSearch";
import {
  useFlightSelectionPayloadContext,
  type FlightType,
} from "../../context/FlightSelectionPayloadContext/FlightSelectionPayloadContext";
import {
  useFlightQuickSearchTokens,
  useFlightSearchTokens,
} from "../useFlightSearchTokens";
import { useFlightFiltersContext } from "../../context/FlightFiltersContext";
import type { FlightSearchPagedResultData } from "./types";
import { getOfferByIdFromSearchResult } from "./utils";

export const useSelectedDepartureFlight = () => {
  const {
    selectedDepartureFlightId,
    selectedOfferIndex,
    selectedFlightSearchSource,
  } = useFlightSelectionPayloadContext();
  const { query: tokensQuery } = useFlightSearchTokens({
    enabled: selectedFlightSearchSource === "full",
  });
  const quickTokensQuery = useFlightQuickSearchTokens();
  const { filters } = useFlightFiltersContext();

  const select = useCallback(
    (response: FlightSearchPagedResultData) => {
      const selectedOffer = getOfferByIdFromSearchResult(
        response,
        selectedOfferIndex,
      );
      if (!selectedOffer) return undefined;

      const selectedDepartureFlight = selectedOffer.flightsOverview.find(
        (fo) => fo.departureFlight.key === selectedDepartureFlightId,
      )?.departureFlight;

      return selectedDepartureFlight;
    },
    [selectedDepartureFlightId, selectedOfferIndex],
  );

  return useFlightSearch<FlightType | undefined>(
    selectedFlightSearchSource === "quick" ? quickTokensQuery : tokensQuery,
    filters,
    {
      select,
    },
  );
};
